import React from "react";
import { connect } from "react-redux";

/**
 * Enterprise Management Scheduler Tab
 *
 **/
class Scheduler extends React.Component {

  render() {

    return (
      <>
        Scheduler
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
  };
};
export default connect(mapStateToProps)(Scheduler);